import { render, staticRenderFns } from "./queryHelpDocument.vue?vue&type=template&id=2793c560&scoped=true"
import script from "./queryHelpDocument.vue?vue&type=script&lang=js"
export * from "./queryHelpDocument.vue?vue&type=script&lang=js"
import style0 from "./queryHelpDocument.vue?vue&type=style&index=0&id=2793c560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2793c560",
  null
  
)

export default component.exports